module.exports = __webpack_public_path__ + "static/media/logo.b5577da2.svg";